<script setup lang="ts">

import {computed} from "vue";

const props = defineProps<{
    skeleton?: boolean,
    inline?: boolean
}>()

const rippleClasses = computed(() => {
    return {
        1: ['scale-[66%]', 'ml-30', '-left-15', 'relative'],
        0: ['h-[200px]', 'my-20']
    }[+(props.inline ?? 0)] ?? []
})

</script>

<template>

    <template v-if="skeleton">
        <div class="animate-pulse">
            <slot></slot>
        </div>
    </template>

    <template v-else>

        <div class="flex justify-center items-center" :class="[...rippleClasses]">
            <div class="ball-scale-ripple-multiple">
                <div class="!border-white"></div>
                <div class="!border-white"></div>
                <div class="!border-white"></div>
            </div>
        </div>

    </template>

</template>